import Scene from "../core/scene";
export const LEVEL_PROGRESSION = [
    [
        { xp: 0, hp: 100, attack: 1 },
        { xp: 400, hp: 120, attack: 1.1 },
        { xp: 800, hp: 150, attack: 1.2 },
        { xp: 1200, hp: 180, attack: 1.5 },
        { xp: 3000, hp: 250, attack: 2.0 },
        { xp: 5000, hp: 500, attack: 3.0 },
    ],
    [
        { xp: 0, hp: 60, attack: .5 },
        { xp: 500, hp: 80, attack: .6 },
        { xp: 1000, hp: 100, attack: .7 },
        { xp: 1500, hp: 120, attack: .8 },
        { xp: 3000, hp: 200, attack: .9 },
        { xp: 5000, hp: 300, attack: 1 },
    ],
    [
        { xp: 0, hp: 80, attack: .8 },
        { xp: 600, hp: 100, attack: .9 },
        { xp: 900, hp: 120, attack: 1.0 },
        { xp: 1200, hp: 130, attack: 1.1 },
        { xp: 3000, hp: 150, attack: 1.5 },
        { xp: 5000, hp: 200, attack: 2.0 },
    ],
    [
        { xp: 0, hp: 100, attack: 0 },
        { xp: 400, hp: 100, attack: 0 },
        { xp: 800, hp: 100, attack: 0 },
        { xp: 1200, hp: 100, attack: 0 },
        { xp: 3000, hp: 100, attack: 0 },
        { xp: 5000, hp: 100, attack: 10.0 },
    ],
];
export class Slide {
    constructor({ asset, from, to, duration, animation, hidden, looping }) {
        this.type = "slideShow";
        this.from = { x: 0, y: 0 };
        this.to = { x: 0, y: 0 };
        this.currentlyHidden = false;
        this.asset = asset;
        this.animation = animation;
        this.from = from;
        this.to = to;
        this.duration = duration;
        this.hidden = hidden !== null && hidden !== void 0 ? hidden : false;
        this.looping = looping;
    }
}
export default class CanvasScene extends Scene {
}
